/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsiReportDto } from '../../models/asi-report-dto';

export interface GetPopularAsiReports$Params {
}

export function getPopularAsiReports(http: HttpClient, rootUrl: string, params?: GetPopularAsiReports$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AsiReportDto>>> {
  const rb = new RequestBuilder(rootUrl, getPopularAsiReports.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AsiReportDto>>;
    })
  );
}

getPopularAsiReports.PATH = '/report/asi/popular';
